
<template>

<base_objects
	ref="objects"
	essence="Объект-аналог"
	essence_name_for_plural_others="объектов-аналогов"
	:service="service"
	single_element_url="expensives"
	:keys_if_all_attrs_hidden="[
		'attrs.expensive_code',
		'attrs.expensive_unit_type',
		'attrs.expensive_name',
		'attrs.expensive_unit_type_count',
		'attrs.expensive_cost_on_date_for_area',
		'attrs.expensive_cost_on_date_for_volume'
	]"
	without_edit_many
/>

</template>

<script>

import base_objects from "../base_objects"

export default
{
	components :
	{
		base_objects,
	},

	data()
	{
		return {
			
			service : "cadastral_analogues_expensive",
    
		}
	},
}

</script>

